import {IProcessFlow} from '~/interfaces/processFlowInterfaces'
import {Hash} from '~/interfaces/hashInterfaces'
import {Module} from "vuex"
import ProcessFlowSubmissionProvider from "~/providers/processFlowSubmissionProvider"

export interface IProcessFlowSubmissionStoreState {
  processFlow: IProcessFlow
  processFlowSubmissionId: string
  modalCancellable: boolean
}

export default function (initialProcessFlow: IProcessFlow): Module<IProcessFlowSubmissionStoreState, {}> {
  const provider = new ProcessFlowSubmissionProvider()

  return {
    namespaced: true,
    state: {
      processFlow: initialProcessFlow,
      processFlowSubmissionId: null,
      modalCancellable: false,
    },
    mutations: {
      init(state, { processFlow }: { processFlow: IProcessFlow }) {
        this.processFlow = processFlow
        this.processFlowSubmissionId = null
      },
      setProcessFlowSubmissionId(state, processFlowSubmissionId) {
        state.processFlowSubmissionId = processFlowSubmissionId
      },
      setModalCancellable(state, cancellable: boolean) {
        state.modalCancellable = cancellable
      },
    },
    actions: {
      /**
       * Right now this always goes through the execute_debug action in the ProcessFlowsController
       * but this is not be the case for flows run through OM actions.
       */
      executeDebug({ commit, state }, payload: { input_variables: Hash, debug: boolean }) {
        return provider.executeDebug(state.processFlow.id, payload)
      },
      resume({ commit, state }, payload: { form_submission_step: Hash, commit: string }) {
        return provider.resume(state.processFlowSubmissionId, payload)
      },
      paused({ commit, state }) {
        return provider.paused(state.processFlowSubmissionId)
      },
    },
  }
}